import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "16",
  height: "16"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#FFF\" stroke=\"#FFF\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"2\" d=\"M15 8H1\"></path><g fill=\"none\" stroke=\"#FFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\"><path d=\"M3.2 11.5v.5M3.2 14.2v.5h.5\"></path><path stroke-dasharray=\"0.8091,2.4273\" d=\"M6.1 14.7h5.3\"></path><path d=\"M12.6 14.7h.5v-.5M13.1 12v-.5\"></path></g><path fill=\"none\" stroke=\"#FFF\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M13.1 4.4V1.3H3.2v3.1\"></path>", 3)
const _hoisted_5 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }